import { render, staticRenderFns } from "./gc-secondary-layout.vue?vue&type=template&id=af3e1284"
import script from "./gc-secondary-layout.vue?vue&type=script&lang=js"
export * from "./gc-secondary-layout.vue?vue&type=script&lang=js"
import style0 from "./gc-secondary-layout.vue?vue&type=style&index=0&id=af3e1284&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports